import { cn } from '~utils/cn'

export type TextInputLabelProps = Readonly<{
  children: string
  isFocused?: boolean
  isError?: boolean
  isDisabled?: boolean
}>

const TextInputLabel = ({ children, isFocused, isError, isDisabled }: TextInputLabelProps) => {
  return (
    <div
      className={cn(
        'mb-1',
        'text-gray-600 text-body-3',
        'transition-colors motion-reduce:transition-none',
        {
          'text-primary-600 dark:text-gray-500': isFocused,
          'text-red-500': isError,
          'text-gray-300': isDisabled,
        }
      )}
    >
      {children}
    </div>
  )
}

export default TextInputLabel
